import { Platform } from 'react-native';

export const getPreferredLocale = (): string => {
  if (Platform.OS === 'web' && typeof globalThis !== 'undefined' && (globalThis as any).navigator?.language) {
    return (globalThis as any).navigator.language as string;
  }
  try {
    // @ts-ignore React Native Intl polyfills may provide default locale
    const rnLocale = (Intl as any)?.DateTimeFormat?.().resolvedOptions?.().locale;
    if (rnLocale) return rnLocale as string;
  } catch {}
  return 'en-US';
};

export const formatEventDate = (iso?: string): string => {
  if (!iso) return '';
  try {
    return new Date(iso).toDateString();
  } catch {
    return '';
  }
};

export const formatEventTimeRange = (start?: string, end?: string): string => {
  if (!start) return 'TBD';
  const startDate = new Date(start);
  const endDate = end ? new Date(end) : undefined;
  const locale = getPreferredLocale();
  const opts: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' };
  const startText = startDate.toLocaleTimeString(locale, opts);
  const endText = endDate ? endDate.toLocaleTimeString(locale, opts) : '';
  return endText ? `${startText} - ${endText}` : startText;
};


